import { useFeatureFlagContext } from './feature-flags.provider';
import { FEATURE_FLAGS } from './feature-flags.constants';

const allFlagsOn = import.meta.env.VITE_FEATURE_FLAGS_ALL_ON === 'true';
const scheduledTasksLocalOverride = import.meta.env.VITE_SCHEDULED_TASKS_ENABLED === 'true';
const ontologyManagementLocalOverride = import.meta.env.DEV;

export function useFeatureFlag(flagKey: string, defaultValue = false): boolean {
  const { isEnabled } = useFeatureFlagContext();
  if (scheduledTasksLocalOverride && flagKey === FEATURE_FLAGS.SCHEDULED_TASKS_ENABLED) return true;
  if (allFlagsOn) return true;
  return isEnabled(flagKey, defaultValue);
}

export function useFeatureFlagsReady(): boolean {
  const { isReady } = useFeatureFlagContext();
  if (allFlagsOn || ontologyManagementLocalOverride) return true;
  return isReady;
}
